var React = require('react');

function Bookmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 3H17C17.5523 3 18 3.44772 18 4V20.3536L12.922 17.7157C12.344 17.4155 11.656 17.4155 11.078 17.7157L6 20.3536V4C6 3.44772 6.44772 3 7 3Z","stroke":"currentColor","strokeWidth":"2"}));
}

Bookmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Bookmark;

Bookmark.default = Bookmark;
